import { Button, Container, Step, StepLabel } from "@mui/material"
import { useApi } from "auth/useApi3"
import ApiResult from "components/ApiResultFeedback"
import ApiButton from "components/Button"
import { Formik } from "formik"
import { apiEndpoints } from "generated/apiEndpoints"
import { useContext, useState } from "react"
import { StepIcon, StyledMobileStepper, StyledStepper } from "shared/styled/FormWizard"
import { CompleteArea } from "./CompleteArea"
import { ImportContext } from "./ImportFormStateProvider"
import { PreviewImportArea } from "./PreviewImportArea"
import { SelectFields } from "./SelectFieldsArea"
import { SuccessArea } from "./SuccessArea"
import { UploadExcelToJson } from "./UploadExcelArea"
import { validationFile, validationSelectedFields } from "./validationSchema"
import { useTranslation } from "react-i18next"

function getSteps(t) {
  return [
    t("vehicleregistry.upload_excel", "Upload excel"),
    t("vehicleregistry.enter_identification", "Enter identification"),
    t("global.preview", "Preview"),
    t("global.buttons.complete", "Complete")
  ]
}

function getStepContent(stepIndex, setFieldValue, touched, errors, values, validateResult, resetForm) {
  switch (stepIndex) {
    case 0:
      return (
        <UploadExcelToJson
          setFieldValue={setFieldValue}
          touched={touched}
          errors={errors}
          values={values}
          resetForm={resetForm}
        />
      )
    case 1:
      return <SelectFields setFieldValue={setFieldValue} touched={touched} errors={errors} values={values} />
    case 2:
      return <PreviewImportArea />
    case 3:
      return <CompleteArea validateResult={validateResult} />

    default:
      return "Unknown"
  }
}

export const ImportFormWizard = () => {
  const { t } = useTranslation()
  const importDataContext = useContext(ImportContext)
  const steps = getSteps(t)
  const [activeStep, setActiveStep] = useState(0)

  const handleNext = () => {
    if (activeStep === 2) {
      validateForm()
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1)
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1)
  }
  const [validateResult, validateFuncs] = useApi()

  const validateForm = () => {
    const rows = importDataContext.getDataToImport()
    validateFuncs.post(apiEndpoints.vehicleregistryadmin.validateimportvehicles, {
      Rows: rows
    })
  }

  const [submitResult, submitFuncs] = useApi()
  const submitForm = () => {
    const rows = importDataContext.getDataToImport()

    submitFuncs.post(apiEndpoints.vehicleregistryadmin.importvehicles, {
      Rows: rows
    })
    setActiveStep(activeStep + 1)
  }

  const schemaArray = [validationFile, validationSelectedFields]
  const [formData] = useState({
    excelFile: "",
    internNumber: "",
    regNumber: "",
    mainPropellant: "HVO",
    vehicleType: "",
    tachographIntegrationActive: false,
    company: ""
  })
  const feedback = {
    errorTitle: t("vehicleregistry.could_not_import_vehicles", "Could not import vehicles")
  }
  return (
    <Formik
      initialValues={formData}
      onSubmit={() => {
        handleNext()
      }}
      validationSchema={schemaArray[activeStep]}>
      {({ values, errors, touched, handleSubmit, setFieldValue, resetForm }) => (
        <form onSubmit={handleSubmit} noValidate>
          {submitResult && submitResult.status === 3 && (
            <ApiResult result={submitResult} feedback={feedback} />
          )}
          <Container>
            {activeStep !== steps.length && (
              <StyledStepper activeStep={activeStep} alternativeLabel>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel StepIconComponent={StepIcon}>{label}</StepLabel>
                  </Step>
                ))}
              </StyledStepper>
            )}
          </Container>
          <div>
            {activeStep === steps.length ? (
              <div>
                <SuccessArea submitResult={submitResult} />
              </div>
            ) : (
              <div>
                {getStepContent(
                  activeStep,
                  setFieldValue,
                  touched,
                  errors,
                  values,
                  validateResult,
                  resetForm
                )}
              </div>
            )}
          </div>

          {activeStep !== steps.length && (
            <StyledMobileStepper
              variant="progress"
              steps={4}
              position="static"
              activeStep={activeStep}
              nextButton={
                activeStep === 4 - 1 ? (
                  <ApiButton
                    color="primary"
                    variant="contained"
                    onClick={submitForm}
                    feedback={{
                      errorTitle: t(
                        "vehicleregistry.could_not_submit_the_sample",
                        "Could not submit the sample"
                      )
                    }}>
                    {t("vehicleregistry.complete_import", "Complete import")}
                  </ApiButton>
                ) : (
                  <Button color="primary" variant="contained" type="submit">
                    {t("global.buttons.next", "Next")}
                  </Button>
                )
              }
              backButton={
                activeStep !== 0 ? (
                  <Button onClick={handleBack} color="inherit">
                    {t("global.buttons.previous", "Previous")}
                  </Button>
                ) : (
                  <div></div>
                )
              }
            />
          )}
        </form>
      )}
    </Formik>
  )
}
